import { useTheme } from '@mui/material';
import { UserIconProps } from './iconProps.interface';

export const WalletIcon = ({ width, height, className }: UserIconProps) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 22H55C58.3137 22 61 24.6863 61 28V46C61 49.3137 58.3137 52 55 52H20C16.6863 52 14 49.3137 14 46V22Z"
                fill={primaryIconStrokeColor}
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50 19H11V41C11 43.2091 12.7909 45 15 45H50C52.2091 45 54 43.2091 54 41V23C54 20.7909 52.2091 19 50 19ZM11 17H9V19V41C9 44.3137 11.6863 47 15 47H50C53.3137 47 56 44.3137 56 41V23C56 19.6863 53.3137 17 50 17H11Z"
                fill={primaryIconStrokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 14H45C47.2091 14 49 15.7909 49 18H51C51 14.6863 48.3137 12 45 12H11C9.89543 12 9 12.8954 9 14V18H11V14Z"
                fill={primaryIconStrokeColor}
            />
            <path
                d="M42 29.5385C42 28.6888 42.6888 28 43.5385 28H55V37H49.4615C45.3406 37 42 33.6594 42 29.5385Z"
                stroke={primaryIconStrokeColor}
                strokeWidth="2"
            />
            <circle cx="47" cy="32" r="2" fill={primaryIconStrokeColor} />
        </svg>
    );
};
